<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SITE')" :vertical="false" />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="siteSelect"
              :pageId="this.$options.name"
              :selected="frame0.selectedCode.COD_SITE"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
              :applyAuthorityYn="N"
            />
          </div>
          <div class="btn_wrap">
            <sui-button type="button" class="comm_btn_Reset" @click="onClickReset">{{ $t('MSG_BTN_RESET') }}</sui-button>
            <sui-button type="button" class="comm_btn_Scr" @click="onClickSearch()">{{ $t('MSG_BTN_SEARCH') }}</sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_shut_wrap">
        <div class="inbox">
         <div class="comm_title_wrap">
           <h4>{{ $t('MSG_TXT_SITE') }}</h4>
         </div>
         <div class="mrB10"></div>
         <sui-grid ref="grid_site" :columns="gridColumns0" :dataset="'ds_site'"
             :hideHeader="true"
             :rowMovable="false"
             :multiselect="false"
             :pageable="false"
             @rowselect="onSelectGrid"
          >
         </sui-grid>
        </div>
        <div class="emptybox">
        </div>
        <div class="inbox">
          <div class="comm_title_wrap">
           <h4>{{ $t('MSG_TXT_COMP_AUTH') }}</h4>
          </div>
          <div class="mrB10"></div>
          <sui-grid ref="grid_oper" :columns="gridColumns1" :dataset="'ds_oper'"
             :hideHeader="true"
             :rowMovable="false"
             :multiselect="false"
             :pageable="false"
          >
          </sui-grid>
        </div>
       </div>
        <div class="comm_btn_wrap">
         <div class="btn_wrapR">
          <sui-button v-permission:update="this.$options.name" type="button" class="comm_btn_solid" @click="onClickSave">{{ $t('MSG_BTN_SAVE') }}</sui-button>
         </div>
        </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  export default {
    name: 'PGE_CMY_00022', // eslint-disable-line vue/name-property-casing
    data() {
      return {
        selectedSiteId: '',
        frame0: {
          selectedCode: {
            COD_SITE: {
              key: '',
              label: '',
            },
          },
          locationName: '',
          locationEnglishName: '',
        },
        localdata0: [],
        gridColumns0: [{
          text: this.$t('MSG_TXT_GNRZ_AREA'),
          datafield: 'generalizationAreaName'
        }, {
          text: this.$t('MSG_TXT_SITE_ID'),
          datafield: 'siteId',
        }, {
          text: this.$t('MSG_TXT_SITE_ABBR'),
          datafield: 'siteAbbreviationName',
        }],
        localdata1: [],
        gridColumns1: [{
          text: this.$t('MSG_TXT_PEHS_WORK_NM'),
          datafield: 'taskName'
        }, {
          text: this.$t('MSG_TXT_USER_GRP_NAME'),
          datafield: 'userGroupName',
        }, {
          text: this.$t('MSG_TXT_COMP_AUTH'),
          datafield: 'authorityPICYn',
          width:"80px",
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
            }, this.ds_oper, this.$refs.grid_oper);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }]
      };
    },
    computed: {
      // 계산된 속성, date pickproperty로 사용가능
    },
    watch: {
      // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
    },
    datasets: [{
      id: 'ds_site',
      type: 'local',
      data: 'localdata0',
      datafields: [
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'siteName', type: 'string', map: 'siteName' },
      { name: 'siteAbbreviationName', type: 'string', map: 'siteAbbreviationName' },
      { name: 'siteEnglishAbbreviationName', type: 'string', map: 'siteEnglishAbbreviationName' },
      { name: 'generalizationAreaCode', type: 'string', map: 'generalizationAreaCode' },
      { name: 'generalizationAreaName', type: 'string', map: 'generalizationAreaName' }]
    },{
      id: 'ds_oper',
      type: 'local',
      data: 'localdata1',
      datafields: [
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'authorityPICYn', type: 'string', map: 'authorityPICYn' },]
    }],
    mounted() {
      // this.ds_site.$on(this.ds_site.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
    },
    destroyed() {
      // this.ds_site.$off(this.ds_site.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    methods: {
      onClickReset(){
        this.$refs.siteSelect.reset();
      },
      onClickSearch() {
        const queryParams = {
          siteId: this.frame0.selectedCode.COD_SITE.key,
        };

        http.request(this.$options.name, 'DTS_CMY_00053', {
          query: queryParams,
        }).then(res => {
          this.ds_site.setRawData(res.data);

          if(this.ds_site.data.length > 0){
            this.ds_site.clearSelection();
            this.ds_site.setSelectedIndex([0]);
          }else{
            this.ds_site.clearSelection();
          }
          this.ds_oper.setRawData([]);
        });
      },
      onSelectGrid(target) {
        const rowIndex = target.args.rowindex;
        if(rowIndex > -1) {
          this.selectedSiteId = this.ds_site.data[rowIndex].siteId;
          const pathParams = {
            'site-id' : this.selectedSiteId,
          };

          http.request(this.$options.name, 'DTS_CMY_00054', {
            path: pathParams,
          }).then(res => {
            this.ds_oper.setRawData(res.data);
          });
        }
      },
      onClickSave(){
        if(this.selectedSiteId) {
          utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
            http.request(this.$options.name, 'DTS_CMY_00055', {
              path: {'site-id' : this.selectedSiteId},
              data: this.ds_oper.data,
            }).then(() => {
              utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
            });
          });
        }
      }
    },
  };
</script>
<style scoped>
</style>
